import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import { navLinks, services } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="paper-texture overflow-hidden border-t border-background-200 bg-background-100 relative">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-[-0.06em] hidden select-none items-start font-poster text-[clamp(900px,72vw,1300px)] font-extrabold leading-none text-white lg:flex"
        style={{ lineHeight: 0.72, marginTop: '-0.035em' }}
      >
        R
      </span>
      <Container className="relative pt-16 md:pt-24">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 md:gap-6">
          <div className="col-span-2 md:col-span-1">
            <p className="font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">AVENOR</p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              Independent accounting, tax and advisory expertise. A considered approach to every number.
            </p>
          </div>
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">Navigate</p>
            <ul className="mt-4 space-y-2">
              <li><Link to="/" className="cursor-pointer text-sm text-foreground-950 hover:text-primary-500">Home</Link></li>
              {navLinks.map((l) => (
                <li key={l.to}><Link to={l.to} className="cursor-pointer text-sm text-foreground-950 hover:text-primary-500">{l.label}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">Expertise</p>
            <ul className="mt-4 grid grid-cols-1 gap-2 lg:grid-cols-2">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/expertise#${s.slug}`} className="cursor-pointer text-sm text-foreground-950 hover:text-primary-500">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="relative mt-16 md:mt-24">
          <div aria-hidden="true" className="relative select-none font-poster text-[27vw] font-extrabold leading-[0.74] tracking-[0.01em] text-primary-500 md:text-[24vw] xl:text-[340px]">
            AVENOR
          </div>
        </div>

        <div className="relative flex flex-col gap-3 border-t border-background-300/70 py-6 font-label text-[11px] uppercase tracking-[0.12em] text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <span>&copy; 2026 AVENOR — Accounting &amp; Advisory</span>
          <span>Template content. Firm, people and articles are illustrative.</span>
        </div>
      </Container>
    </footer>
  );
}